import React, { FC } from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { OPENING_PAID_ADDONS_BY_TYPE } from '@src/constants';
import { PremiumServicesProps } from './props';
import './styles.scss';

export const PremiumServices: FC<PremiumServicesProps> = ({ openingPaidAddons }) => {
  const filteredOpeningPaidAddons = openingPaidAddons.filter(({ type }) => !!OPENING_PAID_ADDONS_BY_TYPE[type]);

  if (filteredOpeningPaidAddons.length === 0) {
    return null;
  }

  return (
    <div className="opening-details-premium-services">
      <div className="opening-details-premium-services__title">Premium services</div>

      {filteredOpeningPaidAddons.map(({ type }, index) => {
        const { icons, title } = OPENING_PAID_ADDONS_BY_TYPE[type]!;

        return (
          <div key={index} className="opening-details-premium-services__item">
            <div
              className={classnames('opening-details-premium-services__icon', {
                'opening-details-premium-services__icon--multi': icons.length > 1,
              })}
            >
              {icons.map((icon, i) => (
                <Svg key={i} src={icon} />
              ))}
            </div>

            <span>{title}</span>
          </div>
        );
      })}
    </div>
  );
};

PremiumServices.propTypes = {
  openingPaidAddons: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};
